<script setup lang="ts">
import { ref, computed, getCurrentInstance } from 'vue'
import { Collapsable, HtmlHeadings } from '~/lib/services/content/content.blocks.dtos'
import { mdToHtml } from '~/lib/markdown'

const props = defineProps<{
  element: Collapsable
  sectionTitle?: string
  isFaqsHome?: boolean
  customUrl?: string
}>()
const route = useRoute()
const isOpen = ref(false)
const instance = getCurrentInstance()
const isMobile = useIsMobile()
const router = useRouter()

const handleClick = () => {
  if (route.fullPath.includes('/faqs') && props.sectionTitle) {
    router.push(`/faqs/${slugify(props.sectionTitle)}/${slugify(props.element.title)}`)
  } else {
    isOpen.value = !isOpen.value
  }
}

const html = mdToHtml(props.element.text !== undefined ? props.element.text : 'No hay contenido')

const collapseIcon = computed(() => {
  if (isMobile.value) return '/images/icons/arrowForward.svg'
  if (isOpen.value) return '/images/icons/arrowUp.svg'
  else return '/images/icons/arrowDown.svg'
})

const hasSlotContent = computed(() => {
  return !!instance?.slots.content
})
onMounted(() => {
  const currentQ = route.params.question?.at(-1)
  if (currentQ === slugify(props.element.title)) isOpen.value = true
})

const renderAs = computed(() => (props.isFaqsHome ? HtmlHeadings.H3 : HtmlHeadings.H2))
</script>

<template>
  <div>
    <!-- LINK TO faqs/:category/:category -->

    <div
      data-test="mcd-accordion__element__visible"
      class="flex cursor-pointer flex-row items-center justify-between px-4 py-3 md:p-0"
      @click="handleClick"
    >
      <RenderTitleAs
        class="text-sm md:text-lg"
        :class="{
          'font-bold': isOpen,
        }"
        :text="props.element.title"
        :render-as="renderAs"
      />
      <a v-if="customUrl" :href="customUrl" class="hidden">{{ props.element.title }}</a>
      <img :src="collapseIcon" alt="collapsable" />
    </div>

    <Transition name="slide-in" appear>
      <section class="mt-2">
        <div
          v-show="isOpen && !hasSlotContent"
          v-dompurify-html="html"
          data-test="mcd-accordion__element__text"
          class="prose prose-sm mb-8 mt-5 max-w-[95%] px-4 text-xs md:prose-base md:mt-6 md:max-w-[95%] md:px-0 md:text-sm"
        ></div>
        <div v-show="isOpen && hasSlotContent" class="max-h-full max-w-full">
          <slot name="content"></slot>
        </div>
      </section>
    </Transition>
  </div>
</template>
